export const validateQuickItemGroupName = (rawName: string): string | null => {
  const name = rawName.trim();
  if (!name) return "그룹명을 입력하세요.";
  if (name.length < 2) return "2자 이상 입력하세요.";
  if (name.length > 100) return "100자 이하로 입력하세요.";
  return null;
};
